/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class BookmarkPopoverService {
  private baseUrl: string = environment.host + '/home/bookmark';

  constructor(private http: HttpClient) {}

  public createBookmark(payload: any) {
    return this.http.post(this.baseUrl, payload).toPromise();
  }

  public updateBookmark(payload: any, id: any) {
    const url = this.baseUrl + '/' + id;
    return this.http.put(url, payload).toPromise();
  }

  public deleteBookmark(id: any) {
    const url = this.baseUrl + '/' + id;
    return this.http.delete(url).toPromise();
  }
}
